module.exports = __webpack_public_path__ + "img/bg-n.526984fe.png";